import React from 'react';
import PropTypes from 'prop-types';
import {useBoolean} from '../../../utils/hooks';

// Images
import expandMenuButton from '../../../assets/images/dropdown/dropdown.svg';
import {makeStyles} from '@mui/styles';
import {useTranslation} from 'react-i18next';
import AppTheme from '../../../conf/AppTheme';

function DropdownContainer({
    style,
    children
}) {
    const { t } = useTranslation();
    const classes = useStyles();

    const [viewDropdown, enableDropdown, disableDropdows] = useBoolean(false);

    return (
        <div style={style} className="DropdownContainer" onMouseLeave={disableDropdows}>
            {/* Header */}
            <div className={classes.actionButtonRoot} onClick={enableDropdown}>
                <div className={classes.actionButtonLeft} />
                <input type="button" value={t('SMC_GEN_ACTIONS')} className={classes.actionButtonMiddle} />
                <div className={classes.actionButtonRight} />
            </div>
            {/* Dropdown */}
            {
                viewDropdown &&
                (
                    <div style={{ position: 'relative' }}>
                        <div className={classes.dropdownRoot}>
                            <div className="dropdown-list-wrap">
                                {
                                    children
                                }
                            </div>
                        </div>
                    </div>
                )
            }
        </div>
    );
}

const useStyles = makeStyles({
    actionButtonRoot: {
        display: 'flex',
        cursor: 'pointer'
    },
    actionButtonLeft: {
        width: '6px',
    },
    actionButtonMiddle: {
        padding: '1px 2px',
        cursor: 'pointer',
        background: 'transparent',
        border: 'none',
        height: '24px',
        color: '#2E3F58'
    },
    actionButtonRight: {
        backgroundImage: `url(${expandMenuButton})`,
        backgroundRepeat: 'no-repeat',
        horizontalAlign: 'middle',
        minWidth: 18,
        alignItems: 'center',
        backgroundPosition: 'center'
    },
    dropdownRoot: {
        position: "absolute",
        right: 0,
        width: (6 + 137 + 18),
        zIndex: AppTheme.zIndexes.actionsDropdown
    }
})

DropdownContainer.propTypes = {
    style: PropTypes.object,
    children: PropTypes.node
}
 
export default DropdownContainer;
